<template>
  <div class="page-title">
    <div class="flex align-center page-title-info">
      <i class="iconfont icondizhi margin-right-xsm"></i>
      <p v-html="pageTitle"></p>
    </div>
    <div class="page-right">
      <div class="refresh " @click="refresh">
        <i class="iconfont iconrefresh" ></i>
      </div>
      <div class="back margin-left" v-if="isBack" @click="back">
        返回
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "pageTitle",
  props:{
    pageTitle:{
      type:String,
      default:''
    },
    isBack:{
      type:Boolean,
      default:false
    }
  },
  methods:{
    refresh(){
      location.reload()
    },
    back(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
.page-title {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 55px;
  padding: 0 30px ;
  background: #fff;
  margin-bottom: 10px;


  .page-title-info {
    color: #999;

    p {
      span {
        color: #333;
      }
    }


  }

  .page-right {
    display: flex;
    align-items: center;

    .refresh {
      width: 50px;
      height: 36px;
      background-color: #009688;
      border-radius: 4px;
      text-align: center;
      line-height: 36px;
      color: #fff;
      cursor: pointer;

      i {
        font-size: 22px;
      }
    }

    .back {
      width: 50px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      color: #fff;
      background-color: #009688;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}
</style>